import React from "react"
import {
  Box, Image, Text, VStack,
} from "@chakra-ui/react"
import printerSvg from "assets/images/printer.svg"

type Props = {
  rollWidth: number
  cutLength: number
  orientation: "parallel" | "perpendicular"
}

const BadgeDimensionsPreview = ({ rollWidth, cutLength, orientation }: Props) => (
  <VStack spacing={2} align="center" my={6}>
    {/* Printer and Roll Container */}
    <Box position="relative" width="full" height="120px" display="flex" alignItems="center">
      <Box
        position="absolute"
        left="0px"
        top="50%"
        transform="translateY(-50%) rotate(-90deg)"
        width="200px"
        height="200px"
        overflow="hidden"
        pointerEvents="none"
        userSelect="none"
      >
        <Image
          src={printerSvg}
          alt="Printer"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Roll Container */}
      <Box
        position="absolute"
        left="100px"
        width="full"
        height={`${Math.min(rollWidth, 100)}px`}
        paddingY={10}
      >
        {/* Badge Strip (clipping container) */}
        <Box
          position="absolute"
          left="0"
          top="50%"
          transform="translateY(-50%)"
          width="100%"
          height={`${rollWidth}px`}
          bg="white"
          borderRadius="sm"
          outline="1px solid"
          outlineColor="gray.300"
          overflow="hidden"
        >
          {/* Cut lines + indicators */}
          {Array.from({ length: 20 }, (_, i) => {
            const cutLengthScale = 1.2
            const scaledCutLength = cutLength * cutLengthScale
            const cutLineX = i * scaledCutLength + 10

            return (
              <React.Fragment key={i}>
                <Box
                  position="absolute"
                  left={`${cutLineX + scaledCutLength / 2}px`}
                  top="50%"
                  transform="translate(-50%, -50%)"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  pointerEvents="none"
                >
                  <Text
                    fontSize={scaledCutLength > 30 ? "lg" : "sm"}
                    fontWeight="bold"
                    color="blue.500"
                    transform={orientation === "perpendicular" ? "rotate(-90deg)" : "none"}
                  >
                    A
                  </Text>
                </Box>

                <Box
                  position="absolute"
                  left={`${cutLineX}px`}
                  top="0"
                  width="1px"
                  height="100%"
                  opacity={0.8}
                  style={{
                    backgroundImage:
            "repeating-linear-gradient(0deg, transparent, transparent 4px, gray 4px, gray 6px)",
                  }}
                />
              </React.Fragment>
            )
          })}
        </Box>

        {/* Roll direction indicator */}
        <Box position="absolute" top="-20px" left="120px" fontSize="xs" color="gray.500">
          →
        </Box>

        {/* Gradient overlay — anchored inside roll container */}
        <Box
          position="absolute"
          right="100px"
          top="0"
          width="40px"
          height="100%"
          pointerEvents="none"
          zIndex={20}
          bgGradient="linear(to-r, rgba(255,255,255,0) 0%, white 100%)"
        />
      </Box>
    </Box>
  </VStack>
)

export default BadgeDimensionsPreview
